import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useCallback, useRef } from "react";
import logo from "assets/images/doorsharp-logo.png";
import {
    useMaterialUIController,
    setMiniSidenav,
} from "context";

export default function AppHeader({ enablePadding = false }) {

    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;

    // Toggle sidenav from the page menu icon
    const isTogglingSidenavRef = useRef(false);
    const handleToggleSidenav = useCallback(() => {
        if (isTogglingSidenavRef.current) return;
        isTogglingSidenavRef.current = true;
        // Defer to next frame to avoid blocking heavy charts paint
        requestAnimationFrame(() => {
            setMiniSidenav(dispatch, !miniSidenav);
            setTimeout(() => {
                isTogglingSidenavRef.current = false;
            }, 150);
        });
    }, [dispatch, miniSidenav]);
    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "56px",
                background: "linear-gradient(90deg, #000000, #1a1a1a)",
                display: "flex",
                alignItems: "center",
                px: enablePadding ? "10px" : "32px",
                zIndex: 5000,
                marginLeft: { xs: "0px", sm: "0px" },
                // marginBottom: { xs: "56px", sm: "56px", md: "0px" },
            }}
            className="mbl-app-header"
        >
            {/* Menu Icon */}
            <IconButton style={{ marginRight:'8px', padding: '4px 0' }} onClick={handleToggleSidenav}>
                <MenuIcon style={{ fontSize: '12px', color: '#ffff' }} />
            </IconButton>

            {/* Logo */}
            <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{ height: 32 }}
            />
        </Box>
    );
}
